import { render, staticRenderFns } from "./material_inventory.vue?vue&type=template&id=479d8931&scoped=true&"
import script from "./material_inventory.vue?vue&type=script&lang=js&"
export * from "./material_inventory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479d8931",
  null
  
)

export default component.exports